import { ModuleWithProviders, NgModule } from '@angular/core';

// SERVICES
import { RequestService } from './services/request.service';

import { RoutingStrategy } from './strategies/routing.strategy';

@NgModule()
export class CoreModule {
    static forRoot(configs: { environment: any }): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [
                RequestService,
                {
                    provide: 'environment',
                    useValue: configs.environment
                },
                RoutingStrategy
            ]
        };
    }
}
